export interface BackgroundPreset {
  id: string;
  name: string;
  thumbnail: string;
  url: string | null; // null for upload option
  isUpload?: boolean;
}

export const BACKGROUND_PRESETS: BackgroundPreset[] = [
  {
    id: 'upload',
    name: 'Upload Image',
    thumbnail: '',
    url: null,
    isUpload: true,
  },
  {
    id: 'banner-day',
    name: 'Banner Day',
    thumbnail: '/backgrounds/BANNER DAY.png',
    url: '/backgrounds/BANNER DAY.png',
  },
  {
    id: 'banner-night',
    name: 'Banner Night',
    thumbnail: '/backgrounds/BANNER NIGHT.png',
    url: '/backgrounds/BANNER NIGHT.png',
  },
  {
    id: 'lost-at-sea',
    name: 'Lost at Sea',
    thumbnail: '/backgrounds/lost at sea banner.png',
    url: '/backgrounds/lost at sea banner.png',
  },
  {
    id: 'sky-base',
    name: 'Sky Base',
    thumbnail: '/backgrounds/banner sky base.png',
    url: '/backgrounds/banner sky base.png',
  },
  {
    id: 'glowy-stars',
    name: 'Glowy Stars',
    thumbnail: '/backgrounds/glowy stars banner.png',
    url: '/backgrounds/glowy stars banner.png',
  },
  {
    id: 'catface',
    name: 'Catface',
    thumbnail: '/backgrounds/catface banner.png',
    url: '/backgrounds/catface banner.png',
  },
  {
    id: 'glow-blue',
    name: 'Glow Blue',
    thumbnail: '/backgrounds/glow blue banner.png',
    url: '/backgrounds/glow blue banner.png',
  },
  {
    id: 'suspended',
    name: 'Suspended',
    thumbnail: '/backgrounds/suspended banner.png',
    url: '/backgrounds/suspended banner.png',
  },
];
